<template>
	<div name="hrms75e-popup-tab2" id="hrms75e-popup-tab2" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">

		  <div class="modal-content">
		  	<div class="modal-header header-popup">
		      <button type="button" class="close" data-dismiss="modal">&times;</button>
		     	  <h4 class="modal-title">{{ labels['HRMS75EC7']['10'] }}</h4>
		    </div>

		    <div class="modal-body detail detail-responsive">
					<div class="box-body">
              <hrms-table :columns="detailTab2PopupColumns" 
                          :data="detailTab2Popup"
                          :searchDisp="false" 
                          :selectRowBool="false"
                          :selectBtnDisp="true"
                          :selectEvent="selectEvent"
                          :confirmSelectBtnDisp="false"
                          ref="popupTab2" />


          </div>
        </div>
        <div class="modal-footer" >
          <button type="button" class="btn bg-color-skin pull-left" data-dismiss="modal" @click="triggerPopupTab2()"><i class="fa fa-check-circle"></i>{{ labelsButton['approve'] }}</button>
        </div>

		  </div>
		 </div>
	</div>

</template>

<script>
export default {
  name: 'hrms75e-popup-tab2',
  data () {
    return {
      btn_close: 'Close',
      selectedRow: []
    }
  },
  props: [ 'labels', 'nowLang', 'detailTab2Popup', 'detail', 'detailTab2PopupColumns', 'setAddCodcours', 'labelsButton' ],
  methods: {
    triggerPopupTab2 () {
      this.$refs.popupTab2.$emit('$selectEventBuiltIn')
    },
    selectEvent (checkedDataRows) {
      this.setAddCodcours(checkedDataRows)
    }
  }
}
</script>


// WEBPACK FOOTER //
// popupTab2.vue?0987399c